import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Realify from './components/Realify';
import Tokenizer from './components/Tokenizer';
import AuroraBackground from './components/AuroraBackground';
import Navbar from './components/Navbar';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Projects from './components/sections/Projects';
import Contact from './components/sections/Contact';
import Footer from './components/sections/Footer';

function Home() {
  return (
    <div className="App">
      <AuroraBackground />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Projects />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function SpiderPage() {
  return (
    <div className="spider-shell">
      <div className="spider-shell__bar">
        <Link className="spider-shell__back" to="/">
          Back to portfolio
        </Link>
      </div>
      <iframe className="spider-shell__frame" title="Spider mode" src="/spider.html" />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/tokenizer" element={<Tokenizer />} />
        <Route path="/realify" element={<Realify />} />
        <Route path="/spider" element={<SpiderPage />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
